module.exports = __webpack_public_path__ + "static/img/ptGame1.71fb75e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame1.png
// module id = 9fVl
// module chunks = 3